import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getAccessRightDetails, doAccessRightCreate, doAccessRightUpdate 
} from "../../../../redux/accessright/accessRightState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { getAccessRightLevelName } from "../../../../utils/index";

const AccessRightForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {							
			recordData.acr_id > 0 ? doUpdate(values): doCreate(values); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="acr_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-3 gap-4">
        			<FormItem className="font-medium mb-2"
		            	name="acr_access_group_id"
		                label="Role/Group"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_access_group_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.accessGroupOptionList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.acr_access_group_name}</label>
		            	}	                
	            	</FormItem>  

					<FormItem className="font-medium mb-2"
		            	name="acr_module_id"
		                label="Module"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_module_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.moduleOptionList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.acr_module_name}</label>
		            	}	                
	            	</FormItem>
				</div>
				<div className="grid grid-cols-5 gap-4">
					<FormItem className="font-medium mb-2"
		            	name="acr_can_view"
		                label="Can View"
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_can_view"
		            		allowClear={true}
						    options={recordData?.accessRightsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessRightLevelName(recordData?.acr_can_view)}</label>
		            	}	                
	            	</FormItem>

					<FormItem className="font-medium mb-2"
		            	name="acr_can_add"
		                label="Can Add"
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_can_add"
		            		allowClear={true}
						    options={recordData?.accessRightsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessRightLevelName(recordData?.acr_can_add)}</label>
		            	}	                
	            	</FormItem>

					<FormItem className="font-medium mb-2"
		            	name="acr_can_edit"
		                label="Can Edit"
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_can_edit"
		            		allowClear={true}
						    options={recordData?.accessRightsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessRightLevelName(recordData?.acr_can_edit)}</label>
		            	}	                
	            	</FormItem>

					<FormItem className="font-medium mb-2"
		            	name="acr_can_delete"
		                label="Can Delete"
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_can_delete"
		            		allowClear={true}
						    options={recordData?.accessRightsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessRightLevelName(recordData?.acr_can_delete)}</label>
		            	}	                
	            	</FormItem>

					<FormItem className="font-medium mb-2"
		            	name="acr_can_extract"
		                label="Can Export"
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_can_extract"
		            		allowClear={true}
						    options={recordData?.accessRightsLevelList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{getAccessRightLevelName(recordData?.acr_can_extract)}</label>
		            	}	                
	            	</FormItem>

	 			</div>	 	
	 			<CrudButtons baseRoute="/console/access-rights" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.accessRight.accessRightDetails?.data,
  	requesting: state.accessRight.accessRightDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAccessRightDetails(id)),
  	doCreate: (data) => dispatch(doAccessRightCreate(data)),
  	doUpdate: (data) => dispatch(doAccessRightUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessRightForm);
